import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DataTable from 'react-data-table-component';
import { Spinner } from 'react-bootstrap';
// import loanimportJSON from '../json-data/loanimportdata.json'
import { configData } from '../../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import { useEncryption } from '../../customHooks/useEncryption';
const LoanImportData = ({ rowDetailsforLoanImportDatas }) => {
  console.log(rowDetailsforLoanImportDatas)
  const [loanimportdata, setLoanImportData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
  // AWS Key Details
  const lambda = new AWS.Lambda({
    region: configData.LAMBDA_REGION,
    accessKeyId: decrypt(getCookie('ak')),
    secretAccessKey: decrypt(getCookie('sk'))
  });

  // console.log(loanimportdata);
  useEffect(() => {
    // console.log("getLoanImportData() - lnGuid", lnGuid);
    // const url = configData.BASE_API_URL;
    const data = {
      Command: configData.GET_LOAN_IMPORT_FOR_LOAN,
      LoanGuid: rowDetailsforLoanImportDatas?.LG,
      SecurityId: null,
      SecurityToken: localStorage.getItem("SecurityToken"),
      EventContextId: null,
      CallerSourceId: null,
      CallerSourceName: null,
    };
    const params = {
      FunctionName: configData.LAMBDA_FUNCTION_NAME1,
      Payload: JSON.stringify(data)
    };


    lambda.invoke(params, (err, data) => {
      if (err) {
        setLoading(false); // Stop loading on error
        console.log(err, err.stack);
      } else {
        let lambdaResponse = JSON.parse(data.Payload.toString());
        const parsedBody = JSON.parse(lambdaResponse.body);
        console.log(parsedBody);

        let response = JSON.parse(JSON.parse(JSON.stringify(parsedBody.Output)));
        // setLoanImportData(response.impdata);
        // loanImportTableData = response.impdata;
        // setLoanImportData(response.impdata); // Update state here
        // setLoading(false); // Stop loading after data is fetched
        // console.log(loanimportdata)
        // / Check if impdata is an array
        if (Array.isArray(response.impdata)) {
          setLoanImportData(response.impdata); // Update state here
        } else {
          console.error("impdata is not an array:", response.impdata);
        }
        setLoading(false); // Stop loading after data is fetched
      }
    });
  }, [rowDetailsforLoanImportDatas])
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('FieldID');
  const [sortOrder, setSortOrder] = useState('asc');

  // Function to handle sorting
  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  // Function to filter data based on search term
  const filteredData = loanimportdata.filter(item =>
    item["Field Name"].toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.Values.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.FieldID.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Function to sort data
  const sortedData = [...filteredData].sort((a, b) => {
    const aValue = a[sortField];
    const bValue = b[sortField];

    if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  // Define columns for the data table
  // const columns = [
  //   {
  //     name: 'Field ID',
  //     selector: 'FieldID',
  //     sortable: true,
  //   },
  //   {
  //     name: 'Field Name',
  //     selector: 'Field Name', // Ensure this matches the key in your data
  //     sortable: true,
  //   },
  //   {
  //     name: 'Values',
  //     selector: 'Values',
  //     sortable: true,
  //   },
  // ];
  return (
    <Row className="m-0">
      <Col sm={12}>
        <div>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control form-control-sm mt-1 mb-1 w-100"
          />

          {loading ? (
            <div className="text-center">
              <Spinner animation="grow" size="sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : sortedData.length > 0 ? (
            <div className="table-container">
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th onClick={() => handleSort('FieldID')} style={{ cursor: 'pointer' }}>
                    Field ID {sortField === 'FieldID' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
                  </th>
                  <th onClick={() => handleSort('Field Name')} style={{ cursor: 'pointer' }}>
                    Field Name {sortField === 'Field Name' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
                  </th>
                  <th onClick={() => handleSort('Values')} style={{ cursor: 'pointer' }}>
                    Values {sortField === 'Values' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.FieldID}</td>
                    <td>{item["Field Name"]}</td>
                    <td>{item.Values}</td>
                  </tr>
                ))}
              </tbody>
            </table></div>
          ) : (
            <div>No data available.</div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default LoanImportData;